import React from 'react';
import {
  ComponentProsAndCons,
  ComponentProsAndConsObj,
} from '$/(cms)/_modules/cmsService/types';
import Cancel from '$/components/icons/CancelIcon';
import CheckCircleGreen from '$/components/icons/CheckCircleGreen';

type ListBlockProps = {
  data: ComponentProsAndConsObj;
  icon: React.ReactNode;
  bgClass: string;
  roundedClass: string;
};

const ListBlock: React.FC<ListBlockProps> = ({
  data,
  icon,
  bgClass,
  roundedClass,
}) => (
  <div
    className={`flex flex-col gap-spacing/gap/y px-spacing/padding/x py-spacing/padding/y ${bgClass} ${roundedClass}`}
  >
    {data.list_title && (
      <h3 className="mhg-alpha-title-1 text-text/primary">{data.list_title}</h3>
    )}

    <ul className="flex flex-col gap-spacing/gap/y-sm">
      {data.point_list?.map((item) => (
        <li key={item.id} className="flex flex-col gap-spacing/gap/y-xs">
          <div className="flex items-center">
            <span className="size-6 shrink-0">{icon}</span>

            {item.title && (
              <h4 className="mhg-alpha-typography-subheading-2  text-text/primary">
                {item.title}
              </h4>
            )}
          </div>

          {item.content && (
            <p className="mhg-alpha-typography-body-1-relaxed pl-6 text-text/secondary">
              {item.content}
            </p>
          )}
        </li>
      ))}
    </ul>
  </div>
);

export const ProsAndCons: React.FC<ComponentProsAndCons> = ({
  section_title,
  intro_content,
  pros,
  cons,
}) => {
  return (
    <div className="flex flex-col gap-spacing/gap/section-y">
      <div className="flex flex-col gap-spacing/gap/y">
        {section_title && (
          <h2 className="mhg-alpha-typography-display-1 text-text/primary">
            {section_title}
          </h2>
        )}

        {intro_content && (
          <p className="mhg-alpha-typography-body-2 text-text/secondary leading-line-height/body-2-relaxed">
            {intro_content}
          </p>
        )}
      </div>

      <div className="grid grid-cols-1 gap-0 md:grid-cols-2">
        {pros && (
          <ListBlock
            data={pros}
            icon={<CheckCircleGreen className="size-5" />}
            bgClass="bg-highlights/green-light"
            roundedClass="rounded-t-radius/card md:rounded-l-radius/card md:rounded-r-none"
          />
        )}

        {cons && (
          <ListBlock
            data={cons}
            icon={<Cancel className="size-5" />}
            bgClass="bg-highlights/red-light"
            roundedClass="rounded-b-radius/card md:rounded-r-radius/card md:rounded-l-none"
          />
        )}
      </div>
    </div>
  );
};
